<div class="modal fade" id="NotificationModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  aria-hidden="true">

  <div class="modal-dialog cascading-modal modal-md" role="document">
    <div class="modal-content" id="notifcationContent">
      <div class="modal-header darken-3 justify-content-center text-center text-white contactmodal">
        <h4 class="text-uppercase font-weight-bold text-center mx-5 pt-2">
          <i class="fa fa-calendar text-white   px-2"></i> Notification Settings
        </h4>
        <button type="button" class="close waves-effect waves-light " data-dismiss="modal" aria-label="Close"
          (click)="dialogRef.close()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <mdb-card-body>
          <p>Fill the details to Schedule the downtime Notifications</p>
          <form ID="formid" class="form" #notificationform="ngForm" (ngSubmit)="onSubmit()" novalidate>
            @if (showalertMsg) {
            <div id="success1" class="toast-alert alert-success mt-3 " role="alert" data-delay="5000"
              data-autohide="false" aria-live="assertive" aria-atomic="true">
              <div class="toast-body">
                <i class="fa fa-check" aria-hidden="true"></i>
                {{alertMsg}}
              </div>
            </div>
            }
            <div id="error" class="toast-alert alert-danger hide mt-3" role="alert" data-delay="5000"
              data-autohide="true" aria-live="assertive" aria-atomic="true">

              <div class="toast-body">
                <i class="fa fa-check" aria-hidden="true"></i>
                {{alertMsg}}
              </div>
            </div>



            <div class="md-form required">
              <select class="browser-default custom-select form-control" name="appType"
                [(ngModel)]="notificationModal.appType" #apptype="ngModel" autocomplete="off">
                <option value="">Select AppType</option>
                @for (at of appTypeList; track at.APPTYPE) {
                <option [value]="at.APPTYPE">
                  {{ at.APPTYPE }}
                </option>
                }
              </select>
            </div>

            <div class="md-form required">
              <input type="date" id="date" #date="ngModel" name="date" mdbInput required autocomplete="off"
                [(ngModel)]="notificationModal.date" placeholder="Start Date" class="form-control">
              <label for="input">Start Date</label>
              @if ((date.touched || notificationform.submitted) && (date.errors?.required || date.errors?.pattern )) {
              <span class="text-danger">
                Valid date is required
              </span>
              }

              &nbsp;&nbsp;

              <input type="date" id="enddate" #enddate="ngModel" name="enddate" mdbInput required autocomplete="off"
                [(ngModel)]="notificationModal.endDate" placeholder="EndDate" class="form-control">
              <label for="input" class="endDate">End Date</label>
              @if ((enddate.touched || notificationform.submitted) && (enddate.errors?.required ||
              enddate.errors?.pattern )) {
              <span class="text-danger">
                Valid Enddate is required
              </span>
              }
            </div>
            <div class="md-form required">
            </div>
            <div class="md-form">
              <select id="UGroup" class="browser-default  custom-select form-control" name="notificationModal.userGroup"
                [(ngModel)]="notificationModal.userGroup" #userGroup="ngModel" required autocomplete="off" multiple>
                <option value="" selected>Select userGroup </option>
                @for (user of userGroupList; track user.ID) {
                <option [value]="user.ID" [id]="user.ID">
                  {{ user.UserGroup }}
                </option>
                }
              </select>

              @if (showError) {
              <span class="text-danger">
                Please select valid userGroup
              </span>
              }

              <!-- <span class="text-danger" *ngIf="(userGroup.touched || notificationform.submitted) && userGroup.errors?.required">
              Please select valid userGroup
            </span> -->
            </div>
            <div class="md-form required">
              <textarea class="form-control" name="message" rows="2" placeholder="Message"
                [(ngModel)]="notificationModal.message" maxlength="2000" autocomplete="off">
            </textarea>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked" #IsCompleted="ngModel"
                name="IsCompleted" [(ngModel)]="notificationModal.IsCompleted" [disabled]="!isDisabled" />
              <label class="form-check-label checkboxclass" for="flexCheckChecked">
                Is Completed
              </label>
            </div>

            <!-- <div class="md-form required form-check">
            <mdb-checkbox [default]="false" #IsCompleted="ngModel" name="IsCompleted"
              [(ngModel)]="notificationModal.IsCompleted"
            class="class="form-check-input"">IsCompleted</mdb-checkbox>
          </div> -->




            <div class="text-center">
              <button type="submit" class="btn basebtn text-uppercase contactbtn mr-3 waves-effect z-depth-0">
                Submit
                <i class="fas fa-angle-double-right"></i>
              </button>



              <button type="reset" class="btn basebtn text-uppercase contactCancelbtn waves-effect z-depth-0"
                (click)="formreset()">
                <i class="fas fa-window-close"></i>
                Reset

              </button>


            </div>


            <div></div>




            <!-- <div class="md-form required">
          <select class="browser-default custom-select" name="appType" [(ngModel)]="notificationModal.appType" #apptype="ngModel" autocomplete="off">
            <option value="">Select AppType</option>
            <option *ngFor="let at of appTypeList" value="{{at.AppType_ID}}">{{at.APPTYPE}}
            </option>
          </select>
        </div> -->

            <!-- <div class="md-form required">
        <input type="date" id="date" #date="ngModel" name="date" mdbInput required autocomplete="off"
          [(ngModel)]="notificationModal.date" placeholder="Start Date">

          <span class="text-danger" *ngIf="(date.touched || notificationform.submitted) && (date.errors?.required || date.errors?.pattern )">
            Valid date is required
          </span>

          <input type="date" id="enddate"  #enddate="ngModel" name="enddate" mdbInput required
            autocomplete="off" [(ngModel)]="notificationModal.endDate" placeholder="EndDate">

            <span class="text-danger" *ngIf="(enddate.touched || notificationform.submitted) && (enddate.errors?.required || enddate.errors?.pattern )">
              Valid Enddate is required
            </span>

          </div>


          <div class="md-form required">
            <select class="browser-default  custom-select"
              name="userGroup"
              [(ngModel)]="notificationModal.userGroup" #userGroup="ngModel"
              required autocomplete="off" multiple [ngModelOptions]="{standalone: true}">
              <option value="" disabled selected>Select userGroup </option>
              <option
                *ngFor="let user of userGroupList"
                [Value]="user.ID">{{user.UserGroup}}
              </option>
            </select>

            <span class="text-danger" *ngIf="(userGroup.touched || notificationform.submitted) && userGroup.errors?.required">
              Please select valid userGroup
            </span>
          </div>








          <div class="md-form required">
            <textarea class="form-control" name="message" rows="2" placeholder="Message"
              [(ngModel)]="notificationModal.message" maxlength="2000" autocomplete="off">
            </textarea>
          </div>
          <div class="md-form required">
            <mdb-checkbox [default]="false" #IsCompleted="ngModel" name="IsCompleted"
            [(ngModel)]="notificationModal.IsCompleted">IsCompleted</mdb-checkbox>
          </div> -->

            <!-- <div class="text-center">
          <button type="submit" class="btn basebtn text-uppercase contactbtn mr-3 waves-effect z-depth-0">
            Submit
            <i class="fas fa-angle-double-right"></i>
          </button>



          <button type="reset" class="btn basebtn text-uppercase contactCancelbtn waves-effect z-depth-0" (click)="formreset()">
            <i class="fas fa-window-close"></i>
            Reset

          </button>


        </div> -->

          </form>

        </mdb-card-body>




      </div>



    </div>

  </div>

</div>